import React, { Component } from 'react'
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";


import CardContent from "@mui/material/CardContent";
import Card from "@mui/material/Card";

import Divider from '@mui/material/Divider';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { ChevronRightRounded } from "@mui/icons-material";

import MUISwitch from '../components/ui-components/toggleSwitch';
import { getURLBase, updateParentHeight } from "../utils/helperFns";

import PastSpendingsScreen from './PastSpendingsScreen';
import TransactionItem from '../components/ui-components/transactionItem';

import axios from 'axios';
import { Button } from '@mui/material';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ py:2 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

export class PastSpendings extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isReady: false,
            tabSelected: 0,
            showFullScreen:false,
            currentViewisMoney: true,
            amountPrefix: "£"
        }
    }
    componentDidMount() {
        console.log("Gid", this.props.gid);
        axios.post(getURLBase(true) + '/pastspendings', { gid: this.props.gid }).then(
            (response) => {
                this.setState({ 
                    committed: response.data.body.committed.slice(0,5), 
                    all: response.data.body.all.slice(0,5), 
                    noncommitted: response.data.body.noncommitted.slice(0,5), 
                    isReady: true });
            })
    }
    
    toggleFullScreen = () => {
        var show = this.state.showFullScreen;
        show = !show;
        this.setState({ showFullScreen: show } );
    }

    handleTabChange = (event, newValue) => {
        this.setState({
            tabSelected: newValue,
        })
    };

    handleSwitchToggle = () => {
        this.setState({
            currentViewisMoney: !this.state.currentViewisMoney,
        });
        if (!this.state.currentViewisMoney) {
            this.setState({ amountPrefix: "£" })
        } else {
            this.setState({ amountPrefix: "kg" })
        }
    };

    render() {
        const WidgetData = () => (
            <Card className="widgetCard cardShadow" sx={{paddingTop:0}} id="parent_PastSpendings">
                <Typography variant="h4" sx={{ fontWeight: 700 }} align="center" marginY={"15px"} gutterBottom>Past Spendings</Typography>
                <Divider light />
                <CardContent textAlign="center" sx={{paddingTop:0}}>
                    <Box sx={{ width: '100%' }}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <Tabs value={this.state.tabSelected}
                                onChange={this.handleTabChange}
                                aria-label="efts and stocks list"
                                variant="fullWidth">
                                <Tab label="All" {...a11yProps(0)} />
                                <Tab label="Committed" {...a11yProps(1)} />
                                <Tab label="Miscellaneous" {...a11yProps(2)} />
                            </Tabs>
                        </Box>
                        <Box>

                            <TabPanel value={this.state.tabSelected} index={0}>
                                <Typography
                                    variant="h6" fontWeight="800" align="center" marginBottom={1}>
                                    This Month
                                </Typography>
                                { this.state.isReady &&
                                    this.state.all.map((transaction, index) => (
                                        <TransactionItem prefix={this.state.amountPrefix} transaction={transaction} co2DataPresent={true} />
                                    ))}
                            </TabPanel>
                            <TabPanel value={this.state.tabSelected} index={1}>
                                <Typography
                                    variant="h6" fontWeight="800" align="center" marginBottom={1}>
                                    This Month
                                </Typography>
                                {this.state.isReady &&
                                    this.state.committed.map((transaction, index) => (
                                        <TransactionItem prefix={this.state.amountPrefix} transaction={transaction} co2DataPresent={true} />
                                    ))}
                            </TabPanel>
                            <TabPanel value={this.state.tabSelected} index={2}>
                                <Typography
                                    variant="h6" fontWeight="800" align="center" marginBottom={1}>
                                    This Month
                                </Typography>
                                {this.state.isReady &&
                                    this.state.noncommitted.map((transaction, index) => (
                                        <TransactionItem prefix={this.state.amountPrefix} transaction={transaction} co2DataPresent={true} />
                                    ))}
                            </TabPanel>                            
                            <Box textAlign="center">
                                <Button variant="outlined"  endIcon={<ChevronRightRounded colorprimary />} textTransformtype="capitalize" onClick={ this.state.all === null ? null :  this.toggleFullScreen }>
                                    See All                                    
                                </Button>
                            </Box>
                        </Box>

                    </Box>
                </CardContent>               
                {this.state.showFullScreen? <PastSpendingsScreen  gid={this.props.gid} toggleHandler={this.toggleFullScreen} currentViewisMoney={this.state.currentViewisMoney}>
                </PastSpendingsScreen>:null}
            </Card>
        );

        return (
            <Box sx={{ position: "relative", width: "100%" }}>
                <Box sx={{ position: "absolute", top: 0, right: 0, zIndex: 1 }}>
                    <MUISwitch handleClick={this.handleSwitchToggle} />
                </Box>
                <WidgetData />
            </Box>
        );
    }

}

export default PastSpendings
